import { render } from "./AuthInit.vue?vue&type=template&id=4cb822e2&ts=true"
import script from "./AuthInit.vue?vue&type=script&lang=ts"
export * from "./AuthInit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__